export const BRAND = {
  name: "Neat & Proper",
  descriptor: "Premium Cleaning & Property Care",
  tagline: "Clean Spaces, better living.",
  motto: "Professional Cleaning. Properly Done.",
  promise: "Your Space. Our Priority.",
  phone: "+234 902 389 0077",
  phoneHref: "tel:+2349023890077",
  email: "neatandproper@techalphahub.online",
  altEmail: "neatandpropercleaning@gmail.com",
  location: "Lagos, Nigeria",
  hours: "Mon – Sat, 8:00am – 6:00pm",
};

export const LAGOS_LGAS = [
  { lga: "Agege", areas: ["Agege", "Ogba", "Pen Cinema", "Dopemu", "Agbotikuyo", "Isokoko"] },
  { lga: "Ajeromi-Ifelodun", areas: ["Ajegunle", "Tolu", "Kirikiri", "Awodi-Ora", "Layeni"] },
  { lga: "Alimosho", areas: ["Egbeda", "Ikotun", "Idimu", "Igando", "Ipaja", "Abule-Egba", "Akowonjo", "Shasha"] },
  { lga: "Amuwo-Odofin", areas: ["Festac Town", "Amuwo-Odofin", "Mile 2", "Satellite Town", "Apple Junction"] },
  { lga: "Apapa", areas: ["Apapa GRA", "Apapa Wharf", "Tin Can Island", "Ijora", "Creek Road"] },
  { lga: "Badagry", areas: ["Badagry Town", "Ajara", "Topo", "Iworo", "Seme Border", "Ibereko"] },
  { lga: "Epe", areas: ["Epe Town", "Eredo", "Mojoda", "Ibefun", "Ita-Opo"] },
  { lga: "Eti-Osa", areas: ["Victoria Island", "Ikoyi", "Lekki Phase 1", "Oniru", "Ajah", "Sangotedo", "Ikate", "Banana Island", "Osborne Foreshore", "Chevron / Orchid", "VGC"] },
  { lga: "Ibeju-Lekki", areas: ["Ibeju", "Eleko", "Lakowe", "Awoyaya", "Abijo", "Bogije", "Free Trade Zone"] },
  { lga: "Ifako-Ijaiye", areas: ["Ifako", "Ijaiye", "Ojokoro", "Agbado", "Meiran"] },
  { lga: "Ikeja", areas: ["Ikeja GRA", "Allen Avenue", "Opebi", "Alausa", "Oregun", "Computer Village", "Ojodu", "Adeniyi Jones"] },
  { lga: "Ikorodu", areas: ["Ikorodu Town", "Igbogbo", "Imota", "Baiyeku", "Ebute", "Ijede"] },
  { lga: "Kosofe", areas: ["Maryland", "Anthony", "Gbagada", "Ogudu", "Ketu", "Mile 12", "Ojota", "Oworonshoki"] },
  { lga: "Lagos Island", areas: ["Isale Eko", "Marina", "CMS", "Obalende", "Onikan", "Dolphin Estate", "Adeniji Adele"] },
  { lga: "Lagos Mainland", areas: ["Yaba", "Ebute Metta", "Sabo", "Jibowu", "Makoko", "Iwaya", "Adekunle"] },
  { lga: "Mushin", areas: ["Mushin", "Idi-Araba", "Ilasamaja", "Papa Ajao", "Ilupeju"] },
  { lga: "Ojo", areas: ["Ojo", "Iba", "Okokomaiko", "Alaba International", "LASU Area"] },
  { lga: "Oshodi-Isolo", areas: ["Oshodi", "Isolo", "Ejigbo", "Ago Palace", "Ire-Akari"] },
  { lga: "Shomolu", areas: ["Shomolu", "Bariga", "Pedro", "Fadeyi", "Onipanu", "Akoka"] },
  { lga: "Surulere", areas: ["Surulere", "Aguda", "Ojuelegba", "Iponri", "Bode Thomas", "Adelabu", "Itire"] },
];

export const SERVICE_CATEGORIES = [
  {
    slug: "residential",
    name: "Residential Cleaning",
    tagline: "A cleaner home. A healthier you.",
    image: "/assets/living.jpg",
    description: "Basic, Deep and Premium cleaning for apartments, flats, terraces and duplexes. Trusted professionals, safe products, spotless results — every single visit.",
    features: ["Basic, Deep & Premium tiers", "Kitchen, bathroom & bedroom detailing", "Vetted, uniformed professionals", "Flexible scheduling"],
  },
  {
    slug: "monthly-plans",
    name: "Monthly Cleaning Plans",
    tagline: "Consistent care. Greater value.",
    image: "/assets/wiping.jpg",
    description: "4 or 8 visits every month at discounted plan rates. Set it once and enjoy a consistently spotless home without lifting a finger.",
    features: ["4 or 8 visits per month", "Priority scheduling", "Same dedicated cleaner", "Deep & Premium upgrades available"],
  },
  {
    slug: "office-business",
    name: "Office & Business Cleaning",
    tagline: "Clean spaces. Productive teams.",
    image: "/assets/office.jpg",
    description: "Offices, shops, salons, restaurants and cafés. We keep your business premises client-ready and your team productive, on your schedule.",
    features: ["Before/after-hours cleaning", "Restroom & kitchen hygiene", "High-touch disinfection", "Custom contracts for large premises"],
  },
  {
    slug: "move-in-out",
    name: "Move-In & Move-Out Cleaning",
    tagline: "Fresh starts. Spotless spaces.",
    image: "/assets/kitchen.jpg",
    description: "Hand over or step into a truly clean space. Full top-to-bottom cleaning, sanitization and detailing before you unpack or hand over keys.",
    features: ["Post-tenant deep sanitize", "Cabinet & wardrobe interiors", "Paint & plaster residue removal", "Balcony & store wash-down"],
  },
  {
    slug: "event-hall",
    name: "Event & Hall Cleaning",
    tagline: "Clean venues. Memorable events.",
    image: "/assets/hallway.jpg",
    description: "Pre-event setup cleaning and post-event restoration for halls, marquees and venues of every size across Lagos.",
    features: ["Pre-event sparkle clean", "Same-day turnaround", "Waste removal & floor care", "Small, medium & large venues"],
  },
  {
    slug: "after-party",
    name: "After-Party Cleanup",
    tagline: "You enjoy the moment. We handle the mess.",
    image: "/assets/clean-desk.jpg",
    description: "House party, owambe or corporate hangout — wake up to a clean home. We handle the cups, stains, spills and everything in between.",
    features: ["Overnight & early-morning crews", "Stain & spill treatment", "Odour treatment available", "Discreet, fast service"],
  },
];

export const PRICING = {
  residential: {
    title: "Residential Cleaning",
    note: "A cleaner home. A healthier you.",
    columns: ["Property", "Basic", "Deep", "Premium"],
    rows: [
      ["Self-Contained", "From ₦15,000", "From ₦25,000", "From ₦35,000"],
      ["1 Bedroom", "From ₦20,000", "From ₦30,000", "From ₦40,000"],
      ["2 Bedroom", "From ₦30,000", "From ₦40,000", "From ₦55,000"],
      ["3 Bedroom", "From ₦40,000", "From ₦50,000", "From ₦65,000"],
      ["4 Bedroom", "From ₦50,000", "From ₦65,000", "From ₦80,000"],
      ["Duplex", "From ₦60,000", "From ₦80,000", "From ₦100,000"],
    ],
  },
  monthly: {
    title: "Monthly Cleaning Plans",
    note: "Consistent care. Greater value. Based on Basic Cleaning — Deep or Premium visits can be added at an additional charge.",
    columns: ["Property", "4 Visits / Month", "8 Visits / Month"],
    rows: [
      ["Self-Contained", "From ₦28,000", "From ₦52,000"],
      ["1 Bedroom", "From ₦36,000", "From ₦68,000"],
      ["2 Bedroom", "From ₦52,000", "From ₦100,000"],
      ["3 Bedroom", "From ₦70,000", "From ₦132,000"],
      ["4 Bedroom", "From ₦88,000", "From ₦164,000"],
      ["Duplex", "From ₦105,000", "From ₦200,000"],
    ],
  },
  office: {
    title: "Office & Business Cleaning",
    note: "Clean spaces. Productive teams. Large offices and business premises — quotation after assessment.",
    columns: ["Service", "Basic", "Premium"],
    rows: [
      ["Small Office", "From ₦20,000", "From ₦30,000"],
      ["Medium Office", "From ₦30,000", "From ₦45,000"],
      ["Shop / Store", "From ₦15,000", "From ₦25,000"],
      ["Salon / Beauty Business", "From ₦15,000", "From ₦25,000"],
      ["Restaurant / Café", "From ₦20,000", "From ₦35,000"],
    ],
  },
  moveInOut: {
    title: "Move-In & Move-Out Cleaning",
    note: "Fresh starts. Spotless spaces.",
    columns: ["Property", "Starting Price"],
    rows: [
      ["Self-Contained", "From ₦30,000"],
      ["1 Bedroom", "From ₦35,000"],
      ["2 Bedroom", "From ₦45,000"],
      ["3 Bedroom", "From ₦60,000"],
      ["4 Bedroom", "From ₦70,000"],
      ["Duplex", "From ₦85,000"],
    ],
  },
  event: {
    title: "Event & Hall Cleaning",
    note: "Clean venues. Memorable events.",
    columns: ["Venue Size", "Basic", "Premium"],
    rows: [
      ["Small", "From ₦30,000", "From ₦45,000"],
      ["Medium", "From ₦50,000", "From ₦70,000"],
      ["Large", "From ₦70,000", "From ₦100,000"],
    ],
  },
  afterParty: {
    title: "After-Party Cleanup",
    note: "You enjoy the moment. We handle the mess.",
    columns: ["Event Size", "Starting Price"],
    rows: [
      ["Small Gathering", "From ₦25,000"],
      ["Medium Party", "From ₦40,000"],
      ["Large Party", "From ₦60,000"],
      ["Very Large Event", "From ₦80,000"],
    ],
  },
  addons: [
    { name: "Refrigerator Cleaning", price: "From ₦8,000", value: 8000 },
    { name: "Oven Cleaning", price: "From ₦7,000", value: 7000 },
    { name: "Microwave Cleaning", price: "From ₦3,000", value: 3000 },
    { name: "Kitchen Cabinet Interior Cleaning", price: "From ₦5,000", value: 5000 },
    { name: "Kitchen Hood / Extractor Cleaning", price: "From ₦5,000", value: 5000 },
    { name: "Balcony Cleaning", price: "From ₦5,000", value: 5000 },
    { name: "Laundry Area Cleaning", price: "From ₦4,000", value: 4000 },
    { name: "Extra Bathroom / Toilet", price: "From ₦5,000", value: 5000 },
    { name: "Interior Window Cleaning", price: "From ₦3,000 / window", value: 3000, unit: "window", quantityBased: true },
    { name: "Exterior Window Cleaning", price: "From ₦5,000 / window", value: 5000, unit: "window", quantityBased: true },
    { name: "Sliding Glass Door Cleaning", price: "From ₦4,000", value: 4000 },
    { name: "Wardrobe Interior Cleaning", price: "From ₦5,000", value: 5000 },
    { name: "Wall Spot Cleaning", price: "From ₦5,000", value: 5000 },
    { name: "Ceiling Fan Cleaning", price: "From ₦3,000", value: 3000 },
    { name: "Air Conditioner Exterior Cleaning", price: "From ₦5,000", value: 5000 },
    { name: "Heavy Grease Removal", price: "From ₦5,000", value: 5000 },
    { name: "Heavy Limescale / Soap-Scum Removal", price: "From ₦5,000", value: 5000 },
    { name: "Pet Hair Removal", price: "From ₦5,000", value: 5000 },
    { name: "Odour Treatment", price: "From ₦5,000", value: 5000 },
    { name: "Post-Move-In / Move-Out Add-On", price: "From ₦10,000", value: 10000 },
  ],
};

export const BASE_PRICES = {
  "Residential Cleaning": {
    tiers: ["Basic", "Deep", "Premium"],
    properties: ["Self-Contained", "1 Bedroom", "2 Bedroom", "3 Bedroom", "4 Bedroom", "Duplex"],
    matrix: {
      "Self-Contained": [15000, 25000, 35000],
      "1 Bedroom": [20000, 30000, 40000],
      "2 Bedroom": [30000, 40000, 55000],
      "3 Bedroom": [40000, 50000, 65000],
      "4 Bedroom": [50000, 65000, 80000],
      "Duplex": [60000, 80000, 100000],
    },
  },
  "Monthly Cleaning Plan": {
    tiers: ["4 Visits / Month", "8 Visits / Month"],
    properties: ["Self-Contained", "1 Bedroom", "2 Bedroom", "3 Bedroom", "4 Bedroom", "Duplex"],
    matrix: {
      "Self-Contained": [28000, 52000],
      "1 Bedroom": [36000, 68000],
      "2 Bedroom": [52000, 100000],
      "3 Bedroom": [70000, 132000],
      "4 Bedroom": [88000, 164000],
      "Duplex": [105000, 200000],
    },
  },
  "Office & Business Cleaning": {
    tiers: ["Basic", "Premium"],
    properties: ["Small Office", "Medium Office", "Shop / Store", "Salon / Beauty Business", "Restaurant / Café"],
    matrix: {
      "Small Office": [20000, 30000],
      "Medium Office": [30000, 45000],
      "Shop / Store": [15000, 25000],
      "Salon / Beauty Business": [15000, 25000],
      "Restaurant / Café": [20000, 35000],
    },
  },
  "Move-In / Move-Out Cleaning": {
    tiers: ["Standard"],
    properties: ["Self-Contained", "1 Bedroom", "2 Bedroom", "3 Bedroom", "4 Bedroom", "Duplex"],
    matrix: {
      "Self-Contained": [30000], "1 Bedroom": [35000], "2 Bedroom": [45000],
      "3 Bedroom": [60000], "4 Bedroom": [70000], "Duplex": [85000],
    },
  },
  "Event & Hall Cleaning": {
    tiers: ["Basic", "Premium"],
    properties: ["Small Venue", "Medium Venue", "Large Venue"],
    matrix: { "Small Venue": [30000, 45000], "Medium Venue": [50000, 70000], "Large Venue": [70000, 100000] },
  },
  "After-Party Cleanup": {
    tiers: ["Standard"],
    properties: ["Small Gathering", "Medium Party", "Large Party", "Very Large Event"],
    matrix: { "Small Gathering": [25000], "Medium Party": [40000], "Large Party": [60000], "Very Large Event": [80000] },
  },
};

export const TIME_SLOTS = ["Morning (8am - 11am)", "Afternoon (12pm - 3pm)", "Evening (4pm - 7pm)"];

export const TESTIMONIALS = [
  {
    name: "Mrs. Adaeze O.",
    location: "Lekki Phase 1",
    text: "Neat & Proper deep-cleaned our 3-bedroom before we moved in. The kitchen looked brand new — even the oven glass. Absolutely worth every naira.",
  },
  {
    name: "Mr. Tunde B.",
    location: "Ikeja GRA",
    text: "We've been on the 4-visits monthly plan for six months. Same friendly team, always on time, and the house smells amazing after every visit.",
  },
  {
    name: "Café Zuri, Yaba",
    location: "Yaba, Lagos Mainland",
    text: "They clean our café every night after close. Health inspection passed with zero issues. Professional, discreet and reliable.",
  },
  {
    name: "Mrs. Kikelomo A.",
    location: "Surulere",
    text: "Booked an after-party cleanup at 11pm, crew arrived 7am the next morning. You'd never know 60 people were in my house. Incredible.",
  },
];

export const formatNaira = (n) => "₦" + Number(n).toLocaleString("en-NG");
